<div class="avatar font" [ngClass]="class">
  <div *ngIf="!user.avatar || user.avatar === ''; else avatarBlock" >
    {{formatedName}}
  </div>
  <ng-template #avatarBlock>
    <img src="{{user.avatar}}">
  </ng-template>
</div>
